<template>
  <div class="row">
    <div class="col-3 align-self-end pb-3" v-for="p in profiles" :key="p._id">
      <div
        v-b-tooltip.hover
        :title="p.name"
        class="rounded-xl  px-5 py-3"
        :class="{
          'no-active': checkPoints(p._id) == 0
        }"
        :style="'background-color:' + bgColor(p.color) + ';'"
      >
        <span class="svg-icon svg-icon-3x svg-icon-danger d-block my-2">
          <i
            class="fas font-size-h2"
            :style="'color:' + p.color"
            :class="p.image"
          ></i>
        </span>
        <a
          href="#"
          class=" font-weight-bold font-size-h5 mt-2"
          :style="'color:' + p.color"
        >
          {{ checkPoints(p._id) }}
        </a>
      </div>
    </div>
    <div class="col-6 align-self-end pb-0" v-if="isMe">
      <div
        v-b-tooltip.hover
        title="Assistance"
        class="rounded-xl  px-5 py-3 bg-secondary"
        :class="{
          'no-active': checkAssistance() == 0
        }"
      >
        <span class="svg-icon svg-icon-3x svg-icon-dark d-block my-2">
          <i class="fas font-size-h2 secondary fa-hand-spock text-dark-75"></i>
        </span>
        <span class=" font-weight-bold font-size-h5 mt-2 text-dark-75">
          {{ checkAssistance() }}
        </span>
      </div>
    </div>
    <div class="col-6 align-self-end pb-0" v-if="isMe">
      <div
        v-b-tooltip.hover
        title="Workshops"
        class="rounded-xl  px-5 py-3 bg-secondary"
        :class="{
          'no-active': checkTrainings() == 0
        }"
      >
        <span class="svg-icon svg-icon-3x svg-icon-dark d-block my-2">
          <i
            class="fas font-size-h2 secondary fa-graduation-cap text-dark-75"
          ></i>
        </span>
        <span class=" font-weight-bold font-size-h5 mt-2">
          {{ checkTrainings() }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProfilesUser",
  props: {
    user: Object
  },
  computed: {
    profiles() {
      return this.$store.getters.getProfiles;
    },

    mySessions() {
      return this.$store.getters.getMySessions;
    },
    isMe() {
      return this.$store.getters.getMyUser._id === this.user._id;
    }
  },
  methods: {
    bgColor(i) {
      let color = i.split("1)");

      return color[0] + "0.3)";
    },
    checkPoints(profile) {
      let punts = this.user.points.profiles.find(p => p.profile == profile);
      return punts ? punts.points : 0;
    },
    checkTrainings() {
      return this.mySessions.filter(a => a.training).length * 200;
    },
    checkAssistance() {
      return this.mySessions.filter(a => a.assistance).length * 100;
    }
  }
};
</script>
<style lang="scss">
.d-grid {
  display: grid;
}
.sessions {
  .d-grid {
    &.grid-sessions {
      grid-template-columns: repeat(1, 100px 30px 30px 1fr 250px 50px);
    }
  }
}
.myUser {
  .grid-profile {
    grid-template-columns: repeat(1, 1fr 3fr);
    .info {
    }
  }
}
</style>
